import type { ReactNode } from "react";
import styles from "./StatCard.module.css";

interface StatCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  color?: string;
}

export function StatCard({ title, value, icon, color }: StatCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.icon} style={color ? { color } : undefined}>
        {icon}
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.value} style={color ? { color } : undefined}>
          {value}
        </div>
      </div>
    </div>
  );
}
